import { FC, useState } from 'react'
import { Paper, Backdrop, Typography, Grid, CircularProgress } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import "./style.scss";
import _ from 'lodash';
import FolderList from './components/FolderList';
import NoteList from './components/NoteList';
import NotesEditor from './components/NotesEditor';

interface NotesPopupTypes {
  open: boolean;
  onClose: () => void;
}

const NotesPopup: FC<NotesPopupTypes> = ({ open, onClose }) => {
  const userData: any = useSelector((state: RootState) => state.user?.user);
  const userId: any = userData?.userDetails?.id || "";

  const [selectedFolderId, setSelectedFolderId] = useState<any>(null);
  const [selectedNoteId, setSelectedNoteId] = useState<any>(null);
  const [selectedNoteContent, setSelectedNoteContent] = useState<any>("");
  const [isContentLoading, setIsContentLoading] = useState<any>(false);
  const [updatedNoteData, setUpdatedNoteData] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [fromNewNote, setFromNewNote] = useState<boolean>(false);

  return (
    <Backdrop
      open={open}
      sx={{ zIndex: 1200 }}
      className="notification-container"
    >
      <Paper
        className="paper"
        sx={{ width: "80%", height: "80vh", padding: 2 }}
      >
        <CloseIcon
          fontSize="medium"
          onClick={onClose}
          sx={{ float: "right" }}
          className='cursor-pointer'
        />
        <Typography variant="h6" sx={{ mb: 2 }}>
          Quick Notes
        </Typography>
        {!isLoading && <Grid container spacing={2} className="wrapper">
          <Grid item xs={3} className={`right-border container-grid`}>
            <FolderList
              userId={userId}
              selectedFolderId={selectedFolderId}
              setSelectedFolderId={setSelectedFolderId}
            />
          </Grid>
          <Grid
            item
            xs={3}
            className={`right-border container-grid`}
          >
            <NoteList
              userId={userId}
              selectedFolderId={selectedFolderId}
              selectedNoteId={selectedNoteId}
              setSelectedNoteId={setSelectedNoteId}
              selectedNoteContent={selectedNoteContent}
              setSelectedNoteContent={setSelectedNoteContent}
              setIsContentLoading={setIsContentLoading}
              updatedNoteData={updatedNoteData}
              setUpdatedNoteData={setUpdatedNoteData}
              setFromNewNote={setFromNewNote}
            />
          </Grid>
          <Grid
            item
            xs={6}
            className="container-grid"
            sx={{ flexGrow: 1, minHeight: 0 }}
          >
            <NotesEditor
              userId={userId}
              selectedNoteId={selectedNoteId}
              selectedNoteContent={selectedNoteContent}
              setSelectedNoteContent={setSelectedNoteContent}
              isContentLoading={isContentLoading}
              setIsContentLoading={setIsContentLoading}
              setUpdatedNoteData={setUpdatedNoteData}
              fromNewNote={fromNewNote}
              setFromNewNote={setFromNewNote}
            />
          </Grid>
        </Grid>}
        <div className="note-popup-loader" >
          {isLoading && <CircularProgress size={50} />}
        </div>
      </Paper>
    </Backdrop>
  )
}

export default NotesPopup;